import currency from 'currency.js';
import { List } from 'antd';
import { isMoment } from 'moment';
import { fieldsPrototypes } from 'helpers/constants';
import { formatDateTime } from 'helpers/Formatter';
import { toSentenceCase } from 'helpers/StringHelper';
import { convertPhoneNumberObjectToString } from 'ui-library/components/InputPhone/InputPhoneHelpers';

const DATE_OPTIONS = Object.freeze({
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: null,
  minute: null,
});

export const formatFieldValue = (fieldValue, fieldType) => {
  if (!fieldType) {
    return '';
  }

  switch (fieldType) {
    case fieldsPrototypes.CurrencyField:
      return currency(fieldValue).format();

    case fieldsPrototypes.DateField:
      return isMoment(fieldValue) ? formatDateTime(fieldValue.toDate(), DATE_OPTIONS) : null;
    case fieldsPrototypes.FileUploadField:
      return (
        <List
          size="small"
          dataSource={fieldValue}
          renderItem={(document) => (
            <List.Item>
              <a href={document.url} target="_blank" rel="noreferrer">
                {document.name}
              </a>
            </List.Item>
          )}
        />
      );
    default:
      return toSentenceCase(String(fieldValue), { useCapitalize: false });
  }
};

export const formatBlock = (block, form, formValidations) => {
  let documents = form.getFieldValue('documents');
  if (documents) {
    documents = formatDocuments(documents);
  }

  if (block.has_rendering_question) {
    block.rendering_question_response = form.getFieldValue('rendering_question_response');
  }

  let values;
  if (block.form_type === 'multi_instance_form') {
    values = form.getFieldsValue(true)?.items;
    // min-amount
    if (values.length < block.min_instances) {
      formValidations['valid'] = false;
      const errorFields = formValidations['errors'];

      formValidations['errors'] = [...errorFields, `At least ${block.min_instances} must be added`];
    }
  } else {
    values = [{ ...form.getFieldsValue(true), documents }];
  }

  const valuesWithFieldId = getValuesWithFieldId(values, block);
  return { ...block, form: formValidations, values: valuesWithFieldId };
};

const getValuesWithFieldId = (values, block) => {
  return values.map((value) => {
    return Object.entries(value).reduce((acc, [fieldName, fieldValue]) => {
      const field = block.fields.find((field) => field.name === fieldName);
      if (field) {
        if (field.field_type === fieldsPrototypes.PhoneField) {
          fieldValue = convertPhoneNumberObjectToString(fieldValue);
        }

        acc.push({
          field_id: field.id,
          attribute: {
            [field.name]: fieldValue,
          },
        });
        return acc;
      } else {
        return acc;
      }
    }, []);
  });
};

const formatDocuments = (documents) => {
  return documents.fileList.reduce((acc, document) => {
    if (document.status === 'done') {
      acc.push({
        id: document.id || document.response.file_upload.id,
        url: document.url || document.response.file_upload.url,
        name: document.name,
        status: document.status,
      });
    }

    return acc;
  }, []);
};
